import { POST } from "../API"
let source;
export const addMessageForConversationApi = (data, conversationId, onSuccess, onError) => {
    source = POST(`/api/v1/chat/conversations/${conversationId}/add_message`, data, onSuccess, onError, true, source)
}